<!-- @format -->

<template>
  <div class="flex flex-col gap-8 p-8">
    <MainHeader />
    <router-view></router-view>
  </div>
</template>

<script setup>
import MainHeader from "@/components/newUi/HRM/MainHeader.vue";
</script>
